var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSplitLinePart = function SvgSplitLinePart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5294_4303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5002 29C20.3287 29 21.0002 29.6716 21.0002 30.5C21.0002 31.3284 20.3287 32 19.5002 32L12.5002 32C11.6718 32 11.0002 31.3284 11.0002 30.5C11.0002 29.6716 11.6718 29 12.5002 29L19.5002 29Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5002 29C31.3287 29 32.0002 29.6716 32.0002 30.5C32.0002 31.3284 31.3287 32 30.5002 32L24.5002 32C23.6718 32 23.0002 31.3284 23.0002 30.5C23.0002 29.6716 23.6718 29 24.5002 29L30.5002 29Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50024 29C8.32867 29 9.00024 29.6716 9.00024 30.5C9.00024 31.3284 8.32867 32 7.50024 32L1.50024 32C0.671817 32 0.000244113 31.3284 0.000244141 30.5C0.000244169 29.6716 0.671817 29 1.50024 29L7.50024 29Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2124 13.9368L19.578 15.5062C19.7337 15.6851 19.9373 15.8146 20.163 15.8782L20.4166 15.9496C20.9078 16.088 21.408 15.7993 21.5338 15.3046C21.6774 14.7394 21.2717 14.1708 20.6931 14.1265L18.2124 13.9368Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6913 15.3923L16.3616 17.3422C16.4406 17.5719 16.4491 17.8191 16.3862 18.0507L16.3179 18.3019C16.1879 18.7798 15.7036 19.0576 15.2254 18.9285C14.6642 18.777 14.3716 18.1436 14.6218 17.6219L15.6913 15.3923Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0002 26C23.1799 26 29.0002 20.1797 29.0002 13C29.0002 5.8203 23.1799 0 16.0002 0C8.82054 0 3.00024 5.8203 3.00024 13C3.00024 20.1797 8.82054 26 16.0002 26ZM9.06103 7.50536C9.31623 7.20077 9.76564 7.15481 10.0876 7.40036L14.8595 11.0395L14.0938 5.08739C14.0421 4.68577 14.3066 4.31956 14.698 4.25084C15.0894 4.18212 15.4729 4.43456 15.5741 4.82749L17.377 11.8293L20.8002 12.0911C22.6487 12.2325 23.945 14.049 23.486 15.8547C23.0843 17.435 21.4863 18.3576 19.9168 17.9154L19.6632 17.8439C19.1882 17.71 18.7494 17.4684 18.3794 17.1399C18.4782 17.6353 18.4621 18.1468 18.3299 18.6332L18.2616 18.8844C17.8436 20.4219 16.2855 21.3155 14.7471 20.9001C12.9418 20.4127 12.0005 18.3751 12.8055 16.697L14.2843 13.6143L9.12239 8.55238C8.83269 8.26829 8.80583 7.80994 9.06103 7.50536Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5294_4303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "currentColor",
    transform: "translate(0.000244141)"
  })))));
};
export default SvgSplitLinePart;